import React, { useState } from "react";
import "./headboard-editorial.scss";
import { ReferenciaCabecera } from "../../../interfaces/ReferenciaCabecera";
// import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import {
  normalizeTwoWords,
  findTarget,
  findRel,
  OptimizeImage,
} from "../../../shared/utils/stringUtilities";
import Breadcrumb from "../../atoms/breadcrumb/breadcrumb";
import Img from "gatsby-image";
import Button from "../../atoms/button/button";
import { RiShareForwardFill } from "react-icons/ri";
import ShareModal from "../../molecules/ShareModal/ShareModal";
import { Link } from "gatsby";

const HeadboardEditorial = (props: ReferenciaCabecera) => {
  const compClass = "o-headboard-editorial";
  const data = props;
  const [isModalVisible, setIsModalVisible] = useState(false);
  const toggleModal = () => {
    setIsModalVisible(!isModalVisible);
  };

  return (
    <div className={`${compClass}`}>
      <ShareModal
        open={isModalVisible}
        onClose={toggleModal}
        gtmClass={`gtm${normalizeTwoWords(
          props.tituloPrincipal
        )}Articulo${normalizeTwoWords(props.tituloPrincipal)}Compartir`}
      />
      <div className={`${compClass}__container`}>
        {data.imagenHeader ? (
          <div className={`${compClass}__container__cover`}>
            {data.imagenHeader.fluid ? (
              <Img
                className={`${compClass}__container__cover__img`}
                fluid={data.imagenHeader.fluid}
                alt={data.imagenHeader.title || "imagen cabecera botones"}
              />
            ) : (
              <img
                className={`${compClass}__container__cover__img`}
                src={OptimizeImage(
                  data.imagenHeader.file.url,
                  data.imagenHeader.file.contentType,
                  550
                )}
                alt={
                  (data.imagenHeader && data.imagenHeader.title) ||
                  "imagen cabecera"
                }
                loading="lazy"
              />
            )}
          </div>
        ) : null}
        <div className={`${compClass}__container__content`}>
          <Breadcrumb content={data.migaDePan} />
          <div className={`${compClass}__container__content__container`}>
            <h1 className={`${compClass}__container__content__name`}>
              {/* {data.referenciaAutor.descripcion.json.content[0].content[0].value}
              {data.referenciaAutor.descripcion.json.content[0].content[1].value} */}
              <span>{data.referenciaAutor.nombreTab.split(" ")[0]} </span>
              {data.referenciaAutor.nombreTab.split(" ")[1]}
            </h1>
            <div className={`${compClass}__container__content__text`}>
              <Link to="/editoriales">
                <span className={`${compClass}__container__content__tag`}>
                  {props.tituloSpan}
                </span>
              </Link>              
              <h2
                className={`${compClass}__container__content__title`}
                dangerouslySetInnerHTML={{ __html: data.tituloPrincipal }}
              ></h2>
              <p>{data.descripcion.json.content[0].content[0].value}</p>
              <div className={`${compClass}__container__content__btns`}>
                <Button
                  onClickAction={toggleModal}
                  text=" compartir"
                  isDisabled={false}
                  classname={`${compClass}__container__content__btns__btn`}
                  IconAlt={<RiShareForwardFill />}
                  type="button"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeadboardEditorial;
